import { render, staticRenderFns } from "./StatusCell.vue?vue&type=template&id=62c18f1c&"
import script from "./StatusCell.vue?vue&type=script&lang=ts&"
export * from "./StatusCell.vue?vue&type=script&lang=ts&"
import style0 from "./StatusCell.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports